module.exports = __webpack_public_path__ + "static/media/illu-header-home-page.eb3577b8.svg";